// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import { connect } from "react-redux";
import React, { useState, useEffect, useCallback } from "react";
import Modal from "react-modal";

import { Updates as StyledUpdates, Form, FormBody } from "./styles";
import { getParent } from "src/utils";
import { SecondaryFooter as Footer } from "src/styles/form";
import { Button } from "src/styles/buttons";

import type { AppState, Updates as UpdatesType } from "src/types";

type Props = {
  updates: UpdatesType
};

const Updates = ({ updates }: Props) => {
  const [showModal, setModal] = useState(false);

  useEffect(() => {
    if (
      process.env.VERSION !== updates.newVersion &&
      updates.newVersion &&
      updates.critical
    ) {
      setModal(true);
    }
  }, [updates, setModal]);

  const handleUpdate = useCallback(
    (e: any) => {
      e.preventDefault();
      // Hard refresh page
      // eslint-disable-next-line no-self-assign
      window.location.href = window.location.href;
    },
    [updates]
  );

  return (
    <StyledUpdates id="app-updates">
      <Modal
        isOpen={showModal}
        parentSelector={() => getParent("#app-updates")}
      >
        <Form onSubmit={handleUpdate}>
          <h4>{i18n.t(k.UPDATE_HAS_BEEN_RELASED)}</h4>
          <FormBody>{i18n.t(k.THERE_IS_A_NEW_VERSION_OF_THE)}</FormBody>
          <Footer>
            <Button type="submit">{i18n.t(k.REFRESH)}</Button>
          </Footer>
        </Form>
      </Modal>
    </StyledUpdates>
  );
};

const mapStateToProps = ({ app }: { app: AppState }) => ({
  updates: app.updates
});

export default connect(mapStateToProps)(Updates);
